import Button from "../../../components/Button"
import Form from "../../../components/Forms"
import { Page } from "../styles"
import { Container } from "./styles"

const PayOptions = () => {

    const handleSubmit = async (e) => {

    }
    return (
        <Page>
            <Container>
                <h1>Opções de Pagamento</h1>
                <p>Escolha os métodos de pagamento disponíveis para os clientes</p>
                <Form
                    onSubmit={handleSubmit}
                    button={
                        <>
                            <div className='confirmation'>
                                <input type='checkbox' className='checkbox' id='checkbox' value='check'/>
                                <label for='checkbox' className='label'>Confirmar Alterações</label>
                            </div>
                            <Button format='submit' type='submit'>Alterar Método de Pagamento</Button>
                        </>
                    }
                >
                    <h3>Pagamento somente por Boleto</h3>
                    <input type="radio" className='radio' id='radio1' value='option1' name='radio-group'/>
                    <label for='radio1' className='label'>Ativar</label>
                    <h3>Pagamento por Boleto e Cartão de Crédito</h3>
                    <input type="radio" className='radio' id='radio2' value='option2' name='radio-group'/>
                    <label for='radio2' className='label'>Ativar</label>
                </Form>
            </Container>
        </Page>
    )
}

export default PayOptions